"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PutBucketAnalyticsConfigurationOutput = {
    type: "structure",
    required: [],
    members: {}
};
//# sourceMappingURL=PutBucketAnalyticsConfigurationOutput.js.map